module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0154.jpg?v=8b4adfa6";